define('viewModels/appView',[
    'viewModels/EmbeddedView'
], function (
    EmbeddedView
) {
    'use strict';

    return new EmbeddedView();
});

